import React from 'react';
import classNames from 'classnames';

import { FormError } from '../../../../components/form';
import { Button } from '../../../../components/general';

import { VideoMode } from '../../../../types';

interface Props {
  videoMode?: VideoMode;
  onChangeVideoMode: (mode: VideoMode) => void;
  error?: string;
}

const ProjectVideoModeSelector: React.FC<Props> = (props) => {
  const { videoMode, onChangeVideoMode, error } = props;

  const eventModes: Record<VideoMode, string> = {
    portrait: '9 x 16',
    landscape: '16 x 9',
  };

  return (
    <div>
      <div className="flex items-center gap-4">
        {(Object.keys(eventModes) as VideoMode[]).map((mode) => (
          <Button
            key={mode}
            onClick={() => onChangeVideoMode(mode)}
            variant="custom"
            colour={mode !== videoMode ? 'grey-outline-salmon' : 'pink'}
            className={classNames({
              'flex flex-col items-center justify-center rounded-md': true,
              'w-[var(--mode-icon-side-a)] sm:w-[calc(var(--mode-icon-side-a)_/_2)] aspect-video':
                mode === 'landscape',
              'h-[var(--mode-icon-side-a)] sm:h-[calc(var(--mode-icon-side-a)_/_2)] aspect-[9/16]':
                mode === 'portrait',
              'bg-grey-100 hover:bg-primary-50': mode !== videoMode,
            })}
          >
            <div className="text-sm font-bold capitalize">{mode}</div>
            <div className="text-sm">{eventModes[mode]}</div>
          </Button>
        ))}
      </div>

      <FormError errMsg={error} />
    </div>
  );
};

export default ProjectVideoModeSelector;
